import { createFiltersInstance } from "modules/utils/createFilteredItemsInstance";

const createOrdersFiltersInstance = ({ SET_FILTERS, getInitialFilters = () => ({}) }) =>
  createFiltersInstance({
    SET_FILTERS,
    initialFilters: {
      assigned_creator_id: null,
      id: null,
      customer_query: null,
      pricing_plan_type: null,
      product_id: null,
      product_type: null,
      company_id: null,
      agent_id: null,
      agent_disbursement_id: null,
      agent_disbursement_status: null,
      platform_disbursement_status: null,
      affiliate_id: null,
      saas: null,
      marketplace: null,
      manual: null,
      automatic: null,
      requires_company_approval: null,
      doesnt_require_company_approval: null,
      no_booking: null,
      static_date_booking: null,
      static_date_range: null,
      created_on: null,
      stock_start_date: null,
      stock_end_date: null,
      status: ["building", "waiting_for_customer_approval", "waiting_for_company_approval", "approved", "finished"],
      payment_type: null,
      balance_status: null,
      author_place: null,
      total_amount_currencies: null,
      customer_locale: null,
      customer_payment_methods: null,
      customer_transfer_date: null,
      payment_profile_id: null,
      payment_profile_name: null,
      without_agent_commision_and_service_fee: null,
      with_agent_commision: null,
      with_agent_service_fee: null,
      with_both_agent_commision_and_service_fee: null,
      with_saas_commision: null,
      notes: null,
      with_notes: null,
      with_affiliate: null,
      with_agent: null,
      ...getInitialFilters(),
    },
    filterTypes: {
      assigned_creator_id: "Number",
      id: "Number",
      customer_query: "String",
      pricing_plan_type: "String",
      product_id: "Number",
      product_type: "String",
      company_id: "Number",
      agent_id: "Number",
      agent_disbursement_id: "Number",
      agent_disbursement_status: "String",
      platform_disbursement_status: "String[]",
      affiliate_id: "Number",
      saas: "Boolean",
      marketplace: "Boolean",
      manual: "Boolean",
      automatic: "Boolean",
      requires_company_approval: "Boolean",
      doesnt_require_company_approval: "Boolean",
      no_booking: "Boolean",
      static_date_booking: "Boolean",
      static_date_range_booking: "Boolean",
      created_on: "Date",
      stock_start_date: "Date",
      stock_end_date: "Date",
      status: "String[]",
      payment_type: "String",
      balance_status: "String[]",
      author_place: "String[]",
      total_amount_currencies: "String[]",
      customer_locale: "String",
      customer_payment_methods: "String[]",
      customer_transfer_date: "Date",
      payment_profile_id: "Number",
      payment_profile_name: "String",
      without_agent_commision_and_service_fee: "Boolean",
      with_agent_commision: "Boolean",
      with_agent_service_fee: "Boolean",
      with_both_agent_commision_and_service_fee: "Boolean",
      with_saas_commision: "Boolean",
      notes: "String",
      with_notes: "Boolean",
      with_affiliate: "Boolean",
      with_agent: "Boolean",
    },
  });

export default createOrdersFiltersInstance;



// WEBPACK FOOTER //
// ./src/modules/orders/OrdersListView/createOrdersFiltersInstance.js